import { render, staticRenderFns } from "./Aliases.vue?vue&type=template&id=118e210e&"
import script from "./Aliases.vue?vue&type=script&lang=js&"
export * from "./Aliases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports